
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 20.5c-1.823-.026-3.49-.469-5-1.328-1.51-.886-2.734-2.11-3.672-3.672C.443 13.912 0 12.245 0 10.5s.443-3.411 1.328-5C2.266 3.937 3.49 2.714 5 1.828 6.51.968 8.177.526 10 .5c1.823.026 3.49.469 5 1.328 1.51.886 2.734 2.11 3.672 3.672.885 1.589 1.328 3.255 1.328 5s-.443 3.412-1.328 5c-.938 1.563-2.162 2.787-3.672 3.672-1.51.86-3.177 1.302-5 1.328zm4.414-11.836c.365-.443.365-.885 0-1.328-.443-.365-.885-.365-1.328 0L8.75 11.672 6.914 9.836c-.443-.365-.885-.365-1.328 0-.365.443-.365.885 0 1.328l2.5 2.5c.443.365.885.365 1.328 0l5-5z","fill":"#74AA00"}})])
          )
        }
      }
    